import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatabricks = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2427_48)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M91.8938 41.2234L50.4796 64.5389L6.13291 39.6276L4 40.7801V58.8654L50.4796 84.929L91.8938 61.7022V71.2768L50.4796 94.5923L6.13291 69.6808L4 70.8334V73.936L50.4796 100L96.8701 73.936V55.8511L94.7373 54.6985L50.4796 79.5212L8.97677 56.2945V46.7199L50.4796 69.9467L96.8701 43.8829V26.0638L94.5597 24.734L50.4796 49.4679L11.1097 27.4823L50.4796 5.4078L82.8288 23.5816L85.6728 21.9858V19.7695L50.4796 1.52588e-05L4 26.0638V28.9007L50.4796 54.9644L91.8938 31.6489V41.2234Z",
			fill: "#EE3D2C"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2427_48",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 100,
			height: 100,
			fill: "white"
		})
	}) })]
});
export default SvgDatabricks;
